module.exports = __webpack_public_path__ + "static/img/experience-manage.fa3a9d3a.png";